<template>
    <div>
        <nav class="bg-nav-bg">
            <div class="mx-auto flex flex-wrap items-center justify-between px-4 py-2">
                <div class="flex items-center gap-3">
                    <button
                        type="button"
                        class="inline-flex flex-col justify-center gap-1 rounded border border-gray-300 p-2 md:hidden"
                        aria-label="Toggle navigation"
                        @click="menuOpen = !menuOpen"
                    >
                        <span class="block h-0.5 w-5 bg-gray-600"></span>
                        <span class="block h-0.5 w-5 bg-gray-600"></span>
                        <span class="block h-0.5 w-5 bg-gray-600"></span>
                    </button>
                    <router-link class="inline-block" to="/">
                        <img :src="logoUrl" class="mt-[-4px] h-5 max-h-5" alt="logo">
                    </router-link>
                </div>

                <div class="w-full md:flex md:w-auto md:flex-1 md:items-center md:justify-between" :class="menuOpen ? 'block' : 'hidden md:flex'">
                    <ul class="mt-3 flex flex-col md:mt-0 md:flex-row md:items-center" v-if="loggedIn">
                        <router-link tag="li" to="/" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.dashboard')}}</a>
                        </router-link>
                        <router-link tag="li" to="/transmitters" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.transmitters')}}</a>
                        </router-link>
                        <router-link tag="li" to="/water-meters" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.water_meters')}}</a>
                        </router-link>
                        <router-link v-if="isUserOwnerOfActiveOrganization" tag="li" to="/valves" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.water_valves')}}</a>
                        </router-link>
                        <router-link tag="li" to="/electricity-meters" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.electricity_meters')}}</a>
                        </router-link>
                        <router-link tag="li" to="/gas-meters" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.gas_meters')}}</a>
                        </router-link>
                        <router-link tag="li" to="/heat-meters" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.heat_meters')}}</a>
                        </router-link>
                        <router-link v-if="isUserOwnerOfActiveOrganization" tag="li" to="/homebases" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.homebases')}}</a>
                        </router-link>
                        <router-link tag="li" to="/split-bill" class="md:hidden">
                            <a class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">&nbsp;&nbsp;{{$t('message.split_bill')}}</a>
                        </router-link>
                        <li v-for="(k, m) in menu" :key="m">
                            <a :href="k" class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">{{m}}</a>
                        </li>
                    </ul>
                    <ul class="mt-2 flex flex-col items-stretch md:mt-0 md:ml-auto md:flex-row md:items-center">
                        <li v-if="loggedIn">
                            <a :href="$t('message.help_link')" target="_blank" class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">{{$t('message.help')}}</a>
                        </li>
                        <li v-if="loggedIn">
                            <router-link to="/logout" class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">{{$t('message.logout')}}</router-link>
                        </li>
                        <li v-if="!loggedIn" class="px-2 py-1">
                            <router-link to="/signup" class="btn btn-danger text-white no-underline">{{$t('message.signup')}}</router-link>
                        </li>
                        <li v-if="!loggedIn">
                            <router-link to="/login" class="block px-3 py-2 text-nav-muted no-underline hover:text-nav-active">{{$t('message.login')}}</router-link>
                        </li>
                        <li class="px-2 py-1">
                            <language/>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <nav class="mb-5 bg-nav-secondary">
            <div class="mx-auto hidden px-4 md:block">
                <ul class="flex flex-wrap" v-if="loggedIn">
                    <router-link tag="li" to="/" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active router-link-exact-active:bg-white router-link-exact-active:text-nav-text">{{$t('message.dashboard')}}</a>
                    </router-link>
                    <router-link tag="li" to="/transmitters" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.transmitters')}}</a>
                    </router-link>
                    <router-link tag="li" to="/water-meters" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.water_meters')}}</a>
                    </router-link>
                    <router-link v-if="isUserOwnerOfActiveOrganization" tag="li" to="/valves" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.water_valves')}}</a>
                    </router-link>
                    <router-link tag="li" to="/electricity-meters" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.electricity_meters')}}</a>
                    </router-link>
                    <router-link tag="li" to="/gas-meters" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.gas_meters')}}</a>
                    </router-link>
                    <router-link tag="li" to="/heat-meters" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.heat_meters')}}</a>
                    </router-link>
                    <router-link v-if="isUserOwnerOfActiveOrganization" tag="li" to="/homebases" exact-active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.homebases')}}</a>
                    </router-link>
                    <router-link tag="li" to="/split-bill" active-class="active">
                        <a class="mt-1 block rounded-t px-2.5 py-2.5 text-nav-muted no-underline hover:text-nav-active">{{$t('message.split_bill')}}</a>
                    </router-link>
                </ul>
            </div>
        </nav>
        <div class="mx-auto px-4">
            <slot></slot>
            <div class="clear-both"></div>
            <hr class="my-4 border-gray-200">
            <small class="print:hidden"><p class="text-center">&copy; BONEGA, {{year}}</p></small>
        </div>
    </div>
</template>

<script>
    import Language from './Language'
    import moment from 'moment'
    import storage from '../_store'
    import mixins from '../modules/mixins'
    import eventBus from '../modules/eventBus'

    export default {
        components: {
            Language
        },
        mixins: [mixins],
        data () {
            return {
                year: moment().format('YYYY'),
                language: '',
                menuOpen: false
            }
        },
        computed: {
            menu () {
                return storage.getters.menu
            },
            loggedIn () {
                return storage.getters.isAuthenticated
            },
            logoUrl () {
                let language = this.language
                switch (window.location.hostname) {
                case 'app.chytrevodomery.cz':
                    language = 'cs'
                    break
                case 'app.wateradmin.com':
                    language = 'en'
                    break
                case 'app.hlidacspotreby.cz':
                    language = 'cs'
                    break
                case 'app.utilitiesadmin.com':
                    language = 'en'
                    break
                }
                switch (language) {
                case 'cs':
                    return '/images/logo-hlidac-spotreby.svg'
                default:
                    return '/images/logo-utilities-admin.svg'
                }
            }
        },
        created () {
            this.stopLanguageListener = eventBus.on('language', (lang) => {
                this.language = lang
            })
        },
        beforeUnmount () {
            this.stopLanguageListener()
        }
    }
</script>

<style>
    .active > a {
        background-color: white !important;
        color: #4A5568 !important;
    }
</style>
